import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { Ionicons } from '@expo/vector-icons';

const PaddingPreview = ({ padding, innerPadding }) => {
  const previewItems = [
    { name: 'Milch', quantity: 2, unit: 'Liter', isPurchased: false },
    { name: 'Brot', quantity: 1, unit: 'Stück', isPurchased: false },
    { name: 'Äpfel', quantity: 1, unit: 'kg', isPurchased: true },
  ];

  return (
    <View style={styles.container}>
      <Text style={styles.title}>Vorschau</Text>
      <View style={styles.previewContainer}>
        <View style={styles.storeHeader}>
          <Text style={styles.storeName}>01 Aldi</Text>
        </View>
        
        {previewItems.map((item, index) => (
          <View 
            key={index} 
            style={[
              styles.itemCard,
              { 
                marginVertical: padding / 2,
                padding: innerPadding || 12
              }
            ]}
          >
            <View style={styles.itemContent}>
              <View style={styles.itemMainRow}>
                <View style={styles.itemLeftColumn}>
                  <View style={styles.itemNameRow}>
                    <Text 
                      style={[
                        styles.itemName,
                        item.isPurchased && styles.itemNamePurchased
                      ]}
                      numberOfLines={1}
                    >
                      {item.isPurchased && '✓ '}
                      {item.name}
                    </Text>
                  </View>
                </View>
                <View style={styles.quantityContainer}>
                  <Text style={styles.itemQuantityNumber}>{item.quantity}</Text>
                  <Text style={styles.itemQuantityUnit}>{item.unit}</Text>
                </View>
              </View>
            </View>
            <View style={styles.itemActions}>
              <View style={styles.checkboxContainer}>
                <Ionicons
                  name={item.isPurchased ? 'checkmark-circle' : 'ellipse-outline'}
                  size={24}
                  color={item.isPurchased ? '#4CAF50' : '#999'}
                />
              </View>
            </View>
          </View>
        ))}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    marginTop: 16,
  },
  title: {
    fontSize: 16,
    fontWeight: '600',
    color: '#333',
    marginBottom: 12,
  },
  previewContainer: {
    backgroundColor: '#f8f9fa',
    borderRadius: 8,
    padding: 12,
    borderWidth: 1,
    borderColor: '#e9ecef',
  },
  storeHeader: {
    backgroundColor: '#4CAF50',
    paddingVertical: 8,
    paddingHorizontal: 12,
    borderRadius: 6,
    marginBottom: 8,
  },
  storeName: {
    color: '#fff',
    fontSize: 16,
    fontWeight: '600',
  },
  itemCard: {
    backgroundColor: '#fff',
    borderRadius: 8,
    flexDirection: 'row',
    alignItems: 'center',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.1,
    shadowRadius: 2,
    elevation: 2,
  },
  itemContent: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
  },
  itemMainRow: {
    flexDirection: 'row',
    alignItems: 'center',
    flex: 1,
  },
  itemLeftColumn: {
    flex: 1,
    justifyContent: 'center',
  },
  itemNameRow: {
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',
    marginBottom: 2,
  },
  itemName: {
    fontSize: 16,
    fontWeight: '600',
    color: '#333',
    marginRight: 8,
    flexShrink: 1,
  },
  itemNamePurchased: {
    textDecorationLine: 'line-through',
    color: '#999',
  },
  quantityContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    alignSelf: 'center',
    marginLeft: 12,
  },
  itemQuantityNumber: {
    fontSize: 16,
    fontWeight: '700',
    color: '#333',
    lineHeight: 18,
  },
  itemQuantityUnit: {
    fontSize: 12,
    color: '#666',
    lineHeight: 14,
  },
  itemActions: {
    flexDirection: 'row',
    alignItems: 'center',
    marginLeft: 10,
  },
  checkboxContainer: {
    padding: 4,
  },
});

export default PaddingPreview;
